import {TokenCredentials} from '../login/tokencredentials';
import {Customer} from '../customer/customer';

export class Order {
    credentials : TokenCredentials;

    id : number;
    version : number;
    userid : number;
    order : string;
    hint : string;
    gate : string;
    customerid : number;
    state : number;
    created : Date;
    updated : Date;
    started : Date;
    finished : Date;

    positions : OrderPos [];
}

export class OrderPos {
    constructor () {
        this.qtyExpected = 0;
        this.qtyReceived = 0;
    }
    id : number;
    version : number;
    userid : number;
    order : string;
    pos : string;
    articleid : number;
    qtyExpected : number;
    qtyReceived : number;
    reservationCode : string;
    state : number;
    created : Date;
    updated : Date;
    started : Date;
    finished : Date;
}

export class OrderListItem {
    id : number;
    order : string;
    hint : string;
    gate : string;
    customer : Customer;
    positionslength: number;
    state : number;
}


// WEBPACK FOOTER //
// /home/pneuser/workspace/pepelogistic/pepeLogisticControl/src/app/order/order.ts